import { Chip } from "@/components/iris";
import { useState } from "react";
import { AlertsTab } from "./alerts-tab";
import { LogsTab } from "./logs-tab";
import { PagesTab } from "./pages-tab";
import { PipelineTab } from "./pipeline-tab";

type Tab = "pipeline" | "pages" | "alerts" | "logs";

export function MonitoringPage() {
  const [tab, setTab] = useState<Tab>("pipeline");

  return (
    <div className="iris-page">
      <h1 className="iris-page__title">Monitoring</h1>
      <p className="iris-page__subtitle">Real-time ingestion health &amp; pipeline monitoring</p>

      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        <Chip active={tab === "pipeline"} onClick={() => setTab("pipeline")}>
          Pipeline
        </Chip>
        <Chip active={tab === "pages"} onClick={() => setTab("pages")}>
          Pages
        </Chip>
        <Chip active={tab === "alerts"} onClick={() => setTab("alerts")}>
          Alerts
        </Chip>
        <Chip active={tab === "logs"} onClick={() => setTab("logs")}>
          Logs
        </Chip>
      </div>

      {tab === "pipeline" && <PipelineTab />}
      {tab === "pages" && <PagesTab />}
      {tab === "alerts" && <AlertsTab />}
      {tab === "logs" && <LogsTab />}
    </div>
  );
}
